import React, { useState } from 'react'
import MetricsGrid from './MetricsGrid'
import TitleButtonContainer from './TitleButtonContainer'
import ServicesUsedChart, {
  topServiceRows,
  ServicesMetric,
  ServicesMetricToggle,
} from './ServicesUsedChart'
import GeographicDistribution, {
  GeographicViewToggle,
} from './GeographicDistribution'
import { GeographicView } from './worksiteDistribution'
import {
  DashboardPeriod,
  DashboardProgramSpend,
  DashboardWorksiteDistribution,
} from '../dashboardTypes'

interface ServicesGeographicGridProps {
  topServices: DashboardProgramSpend[] | null
  period: DashboardPeriod
  onViewFullReport: () => void
  worksites: DashboardWorksiteDistribution[] | null
}

const ServicesGeographicGrid = ({
  topServices,
  period,
  onViewFullReport,
  worksites,
}: ServicesGeographicGridProps) => {
  const [metric, setMetric] = useState<ServicesMetric>('spend')
  const [geoView, setGeoView] = useState<GeographicView>('offices')
  const programs = topServiceRows(topServices, period)

  return (
    <MetricsGrid
      spacing={2}
      marginBottom={3}
      noOfColumns={2}
      columns={[
        <TitleButtonContainer
          title='Top Services Used'
          headerAction={
            <ServicesMetricToggle value={metric} onChange={setMetric} />
          }
          buttonText='View Full Report'
          onClick={onViewFullReport}
          isLoading={programs === null}
        >
          <ServicesUsedChart
            programs={programs ?? []}
            metric={metric}
            period={period}
            style={{ marginTop: '0.5rem' }}
          />
        </TitleButtonContainer>,
        <TitleButtonContainer
          title='Geographic Distribution'
          headerAction={
            <GeographicViewToggle value={geoView} onChange={setGeoView} />
          }
          bodyContainerStyle={{ padding: '0' }}
          style={{ padding: '0' }}
          headerContainerStyle={{ padding: '1.5rem 1.5rem 0 1.5rem' }}
          isLoading={worksites === null}
        >
          <GeographicDistribution sites={worksites ?? []} view={geoView} />
        </TitleButtonContainer>,
      ]}
    />
  )
}

export default React.memo(ServicesGeographicGrid)
